import {
  ProceedingAssetDetailsResponseBody,
  Evaluation as EvaluationResponse,
  ProceedingScope as ProceedingScopeResponse,
} from "../../api/fetch";
import { Classifier } from "../../util/classifierManager";
import { DateString, FormattedDecimal } from "../../util/conversionUtils";

export interface ProceedingAssetDetail
  extends Omit<
    ProceedingAssetDetailsResponseBody,
    "summaTasumisele" | "kasutustasu" | "kasutustasuPeriood" | "hindamised" | "menetlusalad"
  > {
  summaTasumisele?: FormattedDecimal;
  kasutustasu?: FormattedDecimal;
  kasutustasuPeriood?: Classifier;
  hindamised?: Evaluation[];
  menetlusalad?: ProceedingScope[];
}

export interface Evaluation
  extends Omit<
    EvaluationResponse,
    | "tellimuseKp"
    | "vaartuseKp"
    | "vaartusYhikuKohta"
    | "hind"
    | "yhik"
    | "hinnanguKoostaja"
    | "hinnanguKulu"
    | "hinnagaNoustumine"
  > {
  tellimuseKp?: DateString;
  tellimuseKpUTF?: string;
  vaartuseKp?: DateString;
  vaartuseKpUTF?: string;
  vaartusYhikuKohta?: FormattedDecimal;
  hind?: FormattedDecimal;
  yhik?: Classifier;
  hinnanguKoostaja?: Classifier;
  hinnanguKulu?: FormattedDecimal;
  hinnagaNoustumine?: Classifier;
}

export interface ProceedingScope extends Omit<ProceedingScopeResponse, "ulatus" | "pindala"> {
  ulatus?: Classifier;
  pindala?: FormattedDecimal;
}

export enum AppraiserType {
  MAA_AMET = "MAA_AMET",
  HINDAJA = "HINDAJA",
  VALITSEJA = "VALITSEJA",
}

export enum VaraOsisType {
  HOONE = "HOONE",
  RAJATIS = "RAJATIS",
  KATASTRIYKSUS = "KATASTRIYKSUS",
}
